import { render, staticRenderFns } from "./SidebarLevel2.vue?vue&type=template&id=7b9c3fc4"
import script from "./SidebarLevel2.vue?vue&type=script&lang=js"
export * from "./SidebarLevel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports